import { Link } from "react-router-dom";
import { Plane } from "lucide-react";

const Footer = () => (
  <footer className="bg-card border-t border-border mt-auto">
    <div className="max-w-6xl mx-auto px-4 py-10">
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-8">
        <div>
          <Link to="/" className="flex items-center gap-2 text-primary font-display font-bold text-lg mb-3">
            <Plane className="h-5 w-5" />
            Decide My Destination
          </Link>
          <p className="text-sm text-muted-foreground leading-relaxed">
            Free AI-powered travel planning. Discover where your budget takes you.
          </p>
        </div>

        <nav aria-label="Explore links">
          <h4 className="font-display font-semibold text-foreground mb-3">Explore</h4>
          <ul className="space-y-2 text-sm">
            <li><Link to="/" className="text-muted-foreground hover:text-foreground transition-colors">Search Destinations</Link></li>
            <li><Link to="/guides" className="text-muted-foreground hover:text-foreground transition-colors">Travel Guides</Link></li>
            <li><Link to="/about" className="text-muted-foreground hover:text-foreground transition-colors">About Us</Link></li>
          </ul>
        </nav>

        <nav aria-label="Legal links">
          <h4 className="font-display font-semibold text-foreground mb-3">Legal</h4>
          <ul className="space-y-2 text-sm">
            <li><Link to="/privacy" className="text-muted-foreground hover:text-foreground transition-colors">Privacy Policy</Link></li>
            <li><Link to="/terms" className="text-muted-foreground hover:text-foreground transition-colors">Terms of Service</Link></li>
          </ul>
        </nav>
      </div>

      <div className="mt-8 pt-6 border-t border-border text-center text-xs text-muted-foreground">
        © {new Date().getFullYear()} Decide My Destination. All rights reserved.
      </div>
    </div>
  </footer>
);

export default Footer;
